import { render, staticRenderFns } from "./Estate.vue?vue&type=template&id=63b1373e&"
import script from "./Estate.vue?vue&type=script&lang=js&"
export * from "./Estate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/lifecheq/htdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63b1373e')) {
      api.createRecord('63b1373e', component.options)
    } else {
      api.reload('63b1373e', component.options)
    }
    module.hot.accept("./Estate.vue?vue&type=template&id=63b1373e&", function () {
      api.rerender('63b1373e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Calculators/MyCover/Summaries/Tabs/Estate.vue"
export default component.exports